import request from "project-config/services/request/request";
import { useState } from "react";

export function useConsumeTip() {
  const [consumeData, setConsumeData] = useState<{
    consumeTime: number;
    userAccountConsume: number;
    couponConsume: number;
    qyCouponConsume: number;
  }>();
  const fetchConsumeData = async (params: any) => {
    const { data } = await request.post(
      "/api/rendering/task/renderingTask/getConsumeInfo",
      params
    );
    setConsumeData(data);
  };

  return { consumeData, fetchConsumeData };
}
